import { createSignal, Show } from 'solid-js';
import { APP_CONFIG, A11Y, NAVIGATION } from '../../../constants/app-constants';
import { skillsConfig } from '../skills/skills.config';
import PDFPreview from '../../components/PDFPreview/PDFPreview';
import pdfUrl from '../../../../public/pdfs/Resume_Kanav.pdf';
import ProjectIndex from './ProjectIndex';
import WorkLog from './WorkLog';
import {
  FieldRoot,
  StatusBar,
  StatusBrand,
  StatusNav,
  FieldMain,
  Section,
  SectionLabel,
  DisplayName,
  PromptLockup,
  Greeting,
  SkillBands,
  SkillRow,
  SkillKey,
  SkillLink,
  SkillChip,
  ContactRow,
  ContactAction,
  ContactLink,
  FieldFoot,
} from './styled-field';

const skillItems = (list) =>
  list.map((item) => ({
    label: item.label || item.tooltip,
    href: item.href,
  }));

/**
 * Single public field.
 */
const Field = () => {
  const [resumeOpen, setResumeOpen] = createSignal(false);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = APP_CONFIG.resumeFileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <FieldRoot>
      <StatusBar data-testid="status-line">
        <StatusBrand>{'</>'}</StatusBrand>
        <StatusNav aria-label="On-page sections">
          {NAVIGATION.items.map((item) => (
            <a href={item.href}>{item.label}</a>
          ))}
        </StatusNav>
      </StatusBar>

      <FieldMain>
        <Section aria-labelledby="identity-heading">
          <PromptLockup>top :: agent</PromptLockup>
          <DisplayName id="identity-heading">Kanav Sharma</DisplayName>
          <Greeting>Hi there !</Greeting>
          <Greeting>
            I build interfaces, systems, and tools. This page is one field: work I shipped by hand,
            work I shipped with agents, and the log that connects them.
          </Greeting>
          <SkillBands>
            <SkillRow>
              <SkillKey band="amber">ai</SkillKey>
              {skillItems(skillsConfig.orchSkills).map((skill) => (
                <SkillChip band="amber">{skill.label}</SkillChip>
              ))}
            </SkillRow>
            <SkillRow>
              <SkillKey band="green">js</SkillKey>
              {skillItems(skillsConfig.jsSkills).map((skill) => (
                <SkillLink band="green" href={skill.href} target="_blank" rel="noopener noreferrer">
                  {skill.label}
                </SkillLink>
              ))}
            </SkillRow>
            <SkillRow>
              <SkillKey band="green">systems</SkillKey>
              {skillItems(skillsConfig.msSkills).map((skill) => (
                <SkillLink band="green" href={skill.href} target="_blank" rel="noopener noreferrer">
                  {skill.label}
                </SkillLink>
              ))}
            </SkillRow>
            <SkillRow>
              <SkillKey band="amber">agents</SkillKey>
              {skillItems(skillsConfig.aiSkills).map((skill) => (
                <SkillLink band="amber" href={skill.href} target="_blank" rel="noopener noreferrer">
                  {skill.label}
                </SkillLink>
              ))}
            </SkillRow>
          </SkillBands>
        </Section>

        <Section id="projects" data-testid="projects" aria-label={A11Y.labels.portfolioSection}>
          <SectionLabel>index</SectionLabel>
          <ProjectIndex />
        </Section>

        <Section id="work" data-testid="work" aria-label="Work history">
          <SectionLabel>work log</SectionLabel>
          <WorkLog />
        </Section>

        <Section id="contact" data-testid="contact" aria-label="Contact">
          <SectionLabel>contact</SectionLabel>
          <ContactRow>
            <ContactAction
              type="button"
              id="resume-open-btn"
              data-testid="resume-open-btn"
              onClick={() => setResumeOpen(true)}
              aria-label={A11Y.labels.resumePreview}
            >
              résumé
            </ContactAction>
            <ContactLink
              href={APP_CONFIG.linkedIn}
              target="_blank"
              rel="me noopener noreferrer"
              data-testid="linkedin-link"
              aria-label={A11Y.labels.linkedIn}
            >
              LinkedIn
            </ContactLink>
          </ContactRow>
        </Section>

        <FieldFoot>Kanav Sharma</FieldFoot>
      </FieldMain>

      <Show when={resumeOpen()}>
        <PDFPreview
          isOpen={true}
          onClose={() => setResumeOpen(false)}
          pdfUrl={pdfUrl}
          onDownload={handleDownload}
        />
      </Show>
    </FieldRoot>
  );
};

export default Field;
